import * as React from "react"

function Installation(props) {
  return (
    <svg
      viewBox="0 0 110 110"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <circle
        cx={203.698}
        cy={125.424}
        r={70.298}
        fill="#e5eeff"
        transform="translate(-104.271 -43.089) scale(.78164)"
      />
      <path
        d="M59.7 20.561h19.525v29.142H61.273c.059.466.088.961.146 1.457h19.263V19.104h-22.44v20.253a15.98 15.98 0 011.458 3.09V20.56z"
        fill="#052879"
        fillRule="nonzero"
      />
      <path
        d="M61.157 32.509h3.497v-6.994h-3.497v6.994zm.874-2.04h1.749v1.166H62.03v-1.166z"
        fill="#052879"
        fillRule="nonzero"
      />
      <path fill="#052879" d="M70.482 25.515h7.285V43h-7.285z" />
      <path
        d="M65.528 32.509h3.497v-6.994h-3.497v6.994zm.874-2.04h1.749v1.166h-1.749v-1.166zM61.157 40.377h3.497v-6.994h-3.497v6.994zm.874-2.04h1.749v1.166H62.03v-1.166zM65.528 40.377h3.497v-6.994h-3.497v6.994zm.874-2.04h1.749v1.166h-1.749v-1.166zM61.157 48.245h3.497v-6.994h-3.497v6.994zm.874-2.04h1.749v1.166H62.03v-1.165zM65.528 48.245h3.497v-6.994h-3.497v6.994zm.874-2.04h1.749v1.166h-1.749v-1.165z"
        fill="#052879"
        fillRule="nonzero"
      />
      <path
        fill="#052879"
        d="M70.482 43.874h1.166v4.371h-1.166zM72.522 43.874h1.166v4.371h-1.166zM74.562 43.874h1.166v4.371h-1.166zM76.602 43.874h1.165v4.371h-1.165zM61.157 22.018h16.61v2.331h-16.61zM54.92 68.79h30.89v1.661H54.92z"
      />
      <path
        d="M37.407 87.178a3.613 3.613 0 107.227 0v-20.66h1.34v20.66a3.613 3.613 0 107.227 0v-29.49c-1.195.495-2.36.815-3.468 1.02v2.214a.859.859 0 01-.874.874h-7.11a.859.859 0 01-.875-.874v-2.186a19.707 19.707 0 01-3.467-.99v29.432zM46.353 34.695a6.555 6.555 0 005.42-5.596 14.568 14.568 0 01-1.865-.204c-3.351-.524-5.945-1.835-5.857-2.972.437 1.02 3.03 1.778 6.178 1.778 2.39 0 4.43-.437 5.508-1.079.495-.291.757-.64.757-.99 0-1.166-2.797-2.099-6.265-2.099h-.35a6.6 6.6 0 00-4.604-1.894 6.567 6.567 0 00-6.557 6.557c0 3.264 2.39 5.945 5.478 6.47.35.058.7.087 1.079.087s.757 0 1.078-.058z"
        fill="#052879"
        fillRule="nonzero"
      />
      <path
        d="M31.229 65.439l1.282-1.253c.233.087.466.116.728.116h.146c1.282-.087 2.273-1.165 2.186-2.477 0-.204-.03-.408-.03-.64L37 59.726l-1.574-1.573c0-.554-.03-1.108-.03-1.632 0-7.053 1.02-11.016 2.04-13.085v13.085c1.166.524 2.361.845 3.468 1.078v-.787c0-.495.38-.874.875-.874h7.081c.496 0 .874.379.874.874v.758a17.032 17.032 0 003.468-1.108V43.437c.175.35.35.758.525 1.224.816 2.273 1.515 6.003 1.515 11.831 0 1.603-.058 3.38-.175 5.304-.087 1.282.904 2.39 2.186 2.477h.146a2.351 2.351 0 002.33-2.185 97.12 97.12 0 00.176-5.596c0-8.8-1.428-13.667-3.322-16.581-.962-1.457-2.07-2.39-3.119-2.914a5.438 5.438 0 00-2.447-.612c-.175 0-.321 0-.408.029h-4.313l-.641 3.76h-.729l-.641-3.76h-4.226c-.087 0-.233-.03-.408-.03-.524 0-1.428.088-2.447.613-1.574.787-3.264 2.477-4.43 5.478-1.195 3.031-2.01 7.402-2.01 13.988 0 1.72.058 3.556.174 5.596 0 .116.03.233.058.35l-1.34 1.34.408.408-.117.116-4.604 4.575.816.816 4.546-4.516.146-.117.379.408zm16.115-20.487h4.08v.875h-4.08v-.875zm-8.16 0h4.08v.875h-4.08v-.875z"
        fill="#052879"
        fillRule="nonzero"
      />
      <path fill="#052879" d="M24.086 70.09l.973-.965.82.828-.972.964z" />
      <path
        d="M41.457 60.951c0 .175.146.292.292.292h7.081c.175 0 .291-.117.291-.292v-4.167c0-.175-.116-.292-.291-.292h-7.081c-.175 0-.292.117-.292.292v4.167zM77.185 81.467h-4.838v-2.244h.845v-.874H62.934v.874h.846v2.244h-4.838v9.121h18.272l-.03-9.121zm-12.56-1.807h6.848v1.807h-6.848V79.66z"
        fill="#052879"
        fillRule="nonzero"
      />
    </svg>
  )
}

export default Installation
